import { useMemo, useState } from 'react';
import url from '../../../helpers/url';
import mpx from '../../../actions/mpx_data';
import { safelyDecodeBase64 } from '../../../helpers/common';

export const useSeasonList = (seasons, setEpisodes, setRuntimeLength) => {
    const [selectedSeason, setSelectedSeason] = useState(null);
    const [sort, setSort] = useState('asc');

    const onSeasonChanged = async (season: any) => {
        const getEpisodes = await getSeasonEpisodesBySeasonId(season.Id);
        if (sort === 'asc') {
            setEpisodes(getEpisodes);
        } else if (sort == 'desc') {
            const eps = getEpisodes;
            setEpisodes(eps.reverse());
        } else {
            setEpisodes(getEpisodes);
        }
        const seasonLength = getEpisodes
            .map((episode) => episode.duration) // Extract durations
            .reduce((acc, duration) => acc + duration, 0); // Sum durations
        setRuntimeLength(seasonLength);
        setSelectedSeason(season);
    };

    const getSeasonEpisodesBySeasonId = async (id: string) => {
        const episodes = await mpx.getEpisodes(id);
        return episodes;
    };

    const defaultSeason = useMemo(() => {
        const encodedSeason = url.getQuery('season');
        const seasonNumber = encodedSeason ? safelyDecodeBase64(encodedSeason) : null;

        const filteredSeason = seasonNumber
            ? seasons.find((season) => season.tvSeasonNumber == seasonNumber || season.seasonNumber == seasonNumber)
            : seasons[0];
        return filteredSeason;
    }, [seasons]);

    return {
        selectedSeason,
        defaultSeason,
        onSeasonChanged,
    };
};
